import { lazy, Suspense, useState, useRef, useEffect } from "react";
import { useConnection } from "@/hooks/use-connection";
import InteractiveHoverButton from "./ui/interactive-hover-button";
import { triggerConsultaPopup } from "./ConsultaPopup";

const Button = lazy(() => import("@/components/ui/button").then(m => ({ default: m.Button })));
const Dialog = lazy(() => import("@/components/ui/dialog").then(m => ({ default: m.Dialog })));
const DialogContent = lazy(() => import("@/components/ui/dialog").then(m => ({ default: m.DialogContent })));
const DialogTrigger = lazy(() => import("@/components/ui/dialog").then(m => ({ default: m.DialogTrigger })));
const DialogTitle = lazy(() => import("@/components/ui/dialog").then(m => ({ default: m.DialogTitle })));



export const heroTestimonials = [
  {
    id: 1,
    name: "Tatielle",
    image: "https://assets.cdn.filesafe.space/rc8Fx2cZBlMBT1xVdV7Z/media/6a0df93c6f183767bdd34858.webp",
    text: "Virou minha dermatologista preferida! Adoro o atendimento e a atenção durante a consulta. Muito simpática e atenciosa! Estou no início do tratamento e já posso dizer que estou satisfeita pela minha escolha!!!"
  },
  {
    id: 2,
    name: "Francine B.",
    image: "https://assets.cdn.filesafe.space/rc8Fx2cZBlMBT1xVdV7Z/media/6a0df937e05851175c1a764f.webp",
    text: "Dra. Adriana é uma profissional e pessoa fantástica, fazem 02 anos e 06 meses que faço tratamento com ela, eu tinha um Melasma grande nas bochechas, segui orientações dela e minha pele está maravilhosa, tenho antes e depois para provar rs.\nAconselho seguir rigorosamente as instruções dela que em pouco tempo terá resultado.\nCom certeza ela é a melhor, depois dos cuidados dela rejuvenesci 10 anos."
  },
  {
    id: 3,
    name: "Marcella O.",
    image: "https://assets.cdn.filesafe.space/rc8Fx2cZBlMBT1xVdV7Z/media/6a0df935050371b1d3f11309.webp",
    text: "Eu AMEI ter conhecido a doutora Adriana, ela é uma profissional fantástica. Na primeira consulta ela me deu diversas amostras para testar (e eu amei isso!), no meu retorno ela se preocupou em buscar/estudar outras alternativas de produtos para pele que não testam em animais, uma vez que sou vegana. Recomendo demais!!! Muito obrigada pela atenção, dedicação e carinho, doutora."
  },
  {
    id: 4,
    name: "Félix M.",
    image: "https://assets.cdn.filesafe.space/rc8Fx2cZBlMBT1xVdV7Z/media/6a0df9321e90e4b60689c0ce.webp",
    text: "Doutora super atenciosa, me examinou, encaminhou para exames e prescreveu medicação para uso na casa. Consulta de primeira qualidade, consultório moderno, limpo, organizado e bem confortável. Eu indico para todos que necessitam de dermatologista."
  },
  {
    id: 5,
    name: "Suellen",
    image: "https://assets.cdn.filesafe.space/rc8Fx2cZBlMBT1xVdV7Z/media/6a0df93a3202d827cdade2c2.webp",
    text: "Muito atenciosa. O atendimento foi para minha filha de 13 anos. A consulta foi on LINE, pelo convênio, mas mesmo assim o atendimento foi de primeira e tudo muito bem explicado, sem pressa e tirando todas as dúvidas. Eu e minha filha gostamos bastante."
  }
];

interface HeroProps {
  title?: React.ReactNode;
  highlight?: React.ReactNode;
  subtitle?: React.ReactNode;
  image?: string;
  image2?: string;
  className?: string;
  imageClassName?: string;
  subtitleClassName?: string;
  titleClassName?: string;
  sectionClassName?: string;
  containerClassName?: string;
  badgeText?: string;
  statusBadgeText?: string;
  description?: string;
  testimonials?: Array<{id: number, name: string, image: string, text: string}>;
  hideMapButton?: boolean;
  hideUnimed?: boolean;
  disclaimerText?: React.ReactNode;
  statusBadgeClassName?: string;
  atendimentoText?: string;
}

const Hero = ({
  title = <>A atenção e o <br />cuidado</>,
  highlight = "que você merece.",
  subtitle = "A Dra. Adriana Rodrigues é uma dermatologista especializada no tratamento das doenças e patologias que impactam a autoestima e bem-estar da sua pele, cabelos e unhas.",
  image = "https://assets.cdn.filesafe.space/rc8Fx2cZBlMBT1xVdV7Z/media/6a0e37a1e05851175c1e211e.webp",
  image2,
  className = "",
  imageClassName,
  subtitleClassName,
  titleClassName,
  sectionClassName = "relative md:pb-8 overflow-hidden bg-background lg:pt-0 mt-0 pb-0 mb-[-100px] pt-10",
  containerClassName = "container-custom mb-[110px] mt-[90px]",
  badgeText = "Dermatologista em Sorocaba / SP",
  statusBadgeText = "Atendendo presencialmente no Centro de Sorocaba/SP",
  description,
  testimonials = heroTestimonials,
  hideMapButton = false,
  hideUnimed = false,
  disclaimerText = "Não realizamos procedimentos cirúrgicos*",
  statusBadgeClassName = "mt-[-60px]",
  atendimentoText = "Atendimento Particular"
}: HeroProps = {}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const containerRef = useRef<HTMLElement>(null);
  const { isSlow } = useConnection();

  useEffect(() => {
    const timer = setTimeout(() => {
      if ((window as any).removeHeroShell) {
        (window as any).removeHeroShell();
      }
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  const handleImageLoad = () => {
    if ((window as any).removeHeroShell) {
      (window as any).removeHeroShell();
    }
  };


  return (
    <section ref={containerRef} className={sectionClassName}>
      <div className={containerClassName}>
        <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-0 mt-0 ${className}`}>
          <div className="space-y-8">
            <div className="space-y-6">
              <div className="flex items-center gap-3">
                <div className="flex items-center gap-3">
                  <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary/10 text-[#7a181b] font-semibold uppercase tracking-widest text-xs pl-1.5 pr-1.5">
                    {badgeText === "Atendimento Online" ? (
                      <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M23 7l-7 5 7 5V7z" />
                        <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>
                    )}
                    {badgeText}
                  </div>
                </div>
              </div>

              <h1 className={`text-[30px] md:text-[48px] font-serif font-bold leading-[1.1] text-foreground tracking-tight ${titleClassName || ""}`}>
                {title}
              </h1>

              <p className={`text-base md:text-xl text-muted-foreground max-w-lg leading-relaxed font-sans ${subtitleClassName || "pr-[30px]"}`}>
                {description || subtitle}
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-6 pt-2">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-muted/30 flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-primary opacity-70"><path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"/><path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"/></svg>
                </div>
                <div className="flex flex-col">
                  <span className="text-sm font-bold text-foreground">{atendimentoText}</span>
                  <span className="text-sm text-muted-foreground">A partir de R$ 500,00</span>
                </div>
              </div>

              {!hideUnimed && (
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-full bg-[#f3f2f0] shadow-sm flex items-center justify-center overflow-hidden border border-border/50">
                    <div
                      className="w-8 h-8"
                      style={{
                        backgroundColor: '#6e2c30',
                        WebkitMaskImage: 'url(https://assets.cdn.filesafe.space/rc8Fx2cZBlMBT1xVdV7Z/media/6a05d711cf7891b0faa5ab94.svg)',
                        WebkitMaskSize: 'contain',
                        WebkitMaskRepeat: 'no-repeat',
                        WebkitMaskPosition: 'center',
                        maskImage: 'url(https://assets.cdn.filesafe.space/rc8Fx2cZBlMBT1xVdV7Z/media/6a05d711cf7891b0faa5ab94.svg)',
                        maskSize: 'contain',
                        maskRepeat: 'no-repeat',
                        maskPosition: 'center',
                      }}
                      title="Unimed"
                    />
                  </div>
                  <div className="flex flex-col">
                    <span className="text-sm font-bold text-foreground">Planos aceitos</span>
                    <span className="text-sm text-muted-foreground">Unimed</span>
                  </div>
                </div>
              )}
            </div>

            <div className="flex flex-col sm:inline-flex items-center sm:items-stretch pt-4">
              <div className={`flex flex-col sm:flex-row gap-4 ${hideMapButton ? 'w-full justify-center sm:justify-start' : ''}`}>
                <InteractiveHoverButton
                  classes={`bg-primary hover:bg-accent text-white text-base font-semibold shadow-lg shadow-primary/20 py-4 px-8 w-full ${hideMapButton ? 'sm:w-3/4 mx-auto sm:mx-0' : 'sm:w-auto'}`}
                  onClick={triggerConsultaPopup}
                  hoverContent={
                    <>
                      <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                      <span>Abrir WhatsApp</span>
                    </>
                  }
                >
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                  Agendar Consulta
                </InteractiveHoverButton>
                {!hideMapButton && (
                  <Suspense fallback={<div className="w-full sm:w-auto h-14 bg-muted/20 animate-pulse rounded-full" />}>
                    <Dialog>
                      <DialogTrigger asChild>
                        <Button variant="outline" className="rounded-full px-8 py-7 border-primary/20 hover:border-primary/20 text-primary hover:text-primary hover:-translate-y-0 hover:bg-primary/5 text-base font-semibold hover:shadow-none transition-all duration-300 gap-2 w-full sm:w-auto">
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>
                          Ver no Mapa
                        </Button>
                      </DialogTrigger>
                      <DialogContent className="max-w-4xl p-2 bg-white rounded-[2rem] border-none">
                        <DialogTitle className="sr-only">Localização da Clínica</DialogTitle>
                        <div className="w-full h-[60vh] min-h-[400px] rounded-[1.5rem] overflow-hidden relative">
                          <iframe
                            title="Mapa de localização da clínica Dra. Adriana Rodrigues"
                            src="https://maps.google.com/maps?q=Dra.%20Adriana%20Rodrigues,%20Dermatologista,%20Av%20Presidente%20Juscelino%20K%20de%20Oliveira%20660,%20Sorocaba&t=&z=15&ie=UTF8&iwloc=&output=embed"
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            allowFullScreen
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                          />
                          <div className="absolute bottom-24 left-1/2 -translate-x-1/2 sm:bottom-6 sm:left-[80px] sm:translate-x-0">
                            <Button
                              onClick={triggerConsultaPopup}
                              className="bg-[#25D366] hover:bg-[#128C7E] text-white rounded-full px-6 py-6 shadow-lg shadow-[#25D366]/30 hover:-translate-y-1 hover:shadow-xl transition-all duration-300 gap-2 font-semibold text-base"
                            >
                              <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                              Agendar Consulta
                            </Button>
                          </div>
                        </div>
                      </DialogContent>
                    </Dialog>
                  </Suspense>
                )}
              </div>
              <p className={`text-sm text-foreground/80 text-center w-full mt-[26px] ${hideMapButton ? 'ml-0' : 'ml-[-30px]'}`}>
                {disclaimerText}
              </p>
            </div>
          </div>

          <div className="relative mb-[290px] mt-[-22px]">
            <div className="relative aspect-[4/5] md:aspect-auto md:h-[600px] w-full max-w-[500px] mx-auto">
              <div className="w-full h-full relative z-20 mt-[70px] md:mt-[30px]">
                {image2 ? (
                  <div className="relative w-full h-full md:mt-0 mt-4">
                    <img
                      src={isSlow ? `${image}?width=480` : image}
                      srcSet={`${image}?width=480 480w, ${image}?width=800 800w`}
                      sizes="(max-width: 768px) 40vw, 400px"
                      alt="Tratamento"
                      className="absolute top-10 md:top-16 right-0 w-[75%] aspect-[4/3] object-cover rounded-[2rem] shadow-2xl z-10 hover:scale-105 hover:z-30 transition-all duration-500"
                      fetchPriority="high"
                      loading="eager"
                      decoding="async"
                    />
                    <img
                      src={isSlow ? `${image2}?width=480` : image2}
                      srcSet={`${image2}?width=480 480w, ${image2}?width=800 800w`}
                      sizes="(max-width: 768px) 40vw, 400px"
                      alt="Tratamento Detalhe"
                      className="absolute bottom-20 md:bottom-16 left-0 w-[75%] aspect-[6/4] object-cover rounded-[2rem] shadow-2xl z-20 hover:scale-105 hover:z-30 transition-all duration-500"
                      fetchPriority="high"
                      loading="eager"
                      decoding="async"
                      onLoad={handleImageLoad}
                    />
                  </div>
                ) : (
                  <div className="w-full h-full relative">
                    <img
                      src={isSlow ? `${image}?width=480` : `${image}?width=960`}
                      srcSet={`${image}?width=480 480w, ${image}?width=960 960w`}
                      sizes="(max-width: 768px) 100vw, 50vw"
                      alt="Dra. Adriana Rodrigues"
                      width="800"
                      height="1000"
                      className={imageClassName || "w-full h-full object-contain object-bottom transition-transform duration-1000 relative z-10"}
                      fetchPriority="high"
                      loading="eager"
                      decoding="async"
                      onLoad={handleImageLoad}
                    />
                  </div>
                )}
              </div>

              <div className="absolute top-[62px] md:top-[78px] -right-4 md:-right-8 z-30 w-max max-w-[95%]">
                <div className={`bg-white/90 backdrop-blur-md px-4 md:px-6 py-3 rounded-2xl shadow-xl flex items-center gap-3 border border-white/20 animate-float ${statusBadgeClassName}`}>
                  <div className="w-2.5 h-2.5 rounded-full bg-emerald-500 animate-pulse" />
                  <span className="text-xs md:text-sm font-medium text-foreground/80">
                    {statusBadgeText}
                  </span>
                </div>
              </div>

              <div
                className="absolute top-[95%] left-1/2 z-30 w-[95%] md:w-[600px] flex flex-col items-center bg-[#fcfcfa] rounded-[32px] shadow-[0_20px_50px_-12px_rgba(0,0,0,0.1)] border border-black/5 px-2 md:px-8 pb-[20px] pt-0 h-[520px] sm:h-[290px] md:h-[280px] mb-0 mt-[50px] lg:mt-[30px]"
                style={{ transform: 'translateX(-50%)' }}
              >
                <div className="flex -space-x-1 mb-4 relative -mt-5 md:-mt-6">
                  {testimonials.map((t, i) => (
                    <button
                      key={t.id}
                      onClick={() => setActiveIndex(i)}
                      className={`relative rounded-full transition-all duration-300 border-[3px] shadow-lg ${activeIndex === i ? 'border-primary scale-110 z-10 -translate-y-2' : 'border-white hover:scale-110 z-0'}`}
                      aria-label={`Ver depoimento de ${t.name}`}
                    >
                      <img src={t.image} alt="" width="48" height="48" className="w-12 h-12 rounded-full object-cover" loading="lazy" />
                      {activeIndex === i && (
                        <div className="absolute -top-10 left-1/2 -translate-x-1/2 bg-primary text-primary-foreground text-[10px] md:text-xs py-1.5 px-3.5 rounded-full whitespace-nowrap font-medium shadow-xl">
                          {t.name}
                          <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-2 h-2 bg-primary rotate-45" />
                        </div>
                      )}
                    </button>
                  ))}
                </div>

                <div className="flex gap-2 mb-3">
                  {[...Array(5)].map((_, i) => (
                    <svg
                      key={`${activeIndex}-${i}`}
                      viewBox="0 0 24 24"
                      fill="#FFC107"
                      className="w-5 h-5 md:w-6 md:h-6 drop-shadow-sm"
                    >
                      <path fillRule="evenodd" clipRule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z" />
                    </svg>
                  ))}
                </div>

                <div className="flex items-center gap-1 mb-4 md:mb-6 text-emerald-700">
                  <span className="text-[13px] font-medium">Consulta Verificada</span>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-3.5 h-3.5">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>

                <p className="text-foreground/90 italic font-medium h-[250px] sm:h-[150px] md:h-[156px] flex items-start sm:pt-0 sm:items-center justify-center transition-opacity duration-300 leading-relaxed px-2 md:px-10 text-[13px] md:text-sm pb-0 mt-0 text-justify pt-1.5">
                  "{testimonials[activeIndex].text}"
                </p>
              </div>

              <div className="absolute -top-6 -right-6 w-32 h-32 bg-primary/5 rounded-full blur-3xl -z-10" />
              <div className="absolute -bottom-10 -left-10 w-48 h-48 bg-primary/10 rounded-full blur-3xl -z-10" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
